<template>
    <div v-if="loaded" class="nevs-content">
        <div class="nevs-content-top-buttons">
            <NevsButton class="success help-save" @click="saveClick()"><i class="fa-solid fa-floppy-disk"></i>
                {{ $LANG.Get('buttons.save') }}
            </NevsButton>&nbsp;
            <NevsButton class="error help-back" @click="backClick"><i class="fa-solid fa-arrow-left"></i> {{
                    $LANG.Get('buttons.back')
                }}
            </NevsButton>
        </div>
        <NevsCard class="company-form">
            <h2>{{ $LANG.Get('labels.generalData') }}</h2>

            <div class="company-form-grid">
                <NevsTextField v-model="company.name" :error="companyValidation.name"
                               :label="'*' + $LANG.Get('fields.name') + ':'"></NevsTextField>
                <div class="company-form-oib">
                    <NevsTextField v-model="company.oib" :error="companyValidation.oib"
                                   :label="$LANG.Get('fields.oib') + ':'"></NevsTextField>
                    <NevsButton :title="$LANG.Get('tooltips.getDataFromRegister')" @click="getDataFromRegister"><i
                        class="fa-solid fa-magnifying-glass"></i></NevsButton>
                </div>
            </div>

            <div class="company-form-foreign">
                <NevsTextField v-if="company.foreign" :width="'300px'" v-model="company.oib_label"
                               :error="companyValidation.oib_label"
                               :label="$LANG.Get('fields.oibLabel') + ':'"></NevsTextField>
                <NevsCheckbox class="help-foreign" v-model="company.foreign"
                              :label="$LANG.Get('fields.foreignClient')"></NevsCheckbox>
            </div>

            <div class="company-form-flags">
                <NevsCheckbox class="help-active" v-model="company.active"
                              :label="$LANG.Get('fields.activeF')"></NevsCheckbox>
            </div>

            <div class="company-form-sections">
                <div class="company-form-section">
                    <h2 class="help-emails">{{ $LANG.Get('labels.emails') }}</h2>
                    <div v-if="companyValidation.emails" class="box-error nevs-text-error">{{ companyValidation.emails }}</div>
                    <div v-for="(email, key) in company.emails" :key="key" class="box-form">
                        <NevsTextField :error="email.validation" :label="'*' + $LANG.Get('fields.address') + ':'"
                                       v-model="email.address"></NevsTextField>
                        <NevsCheckbox :label="$LANG.Get('fields.emailDocuments')" v-model="email.documents"></NevsCheckbox>
                        <span @click="removeRecord(key, 'emails')" :title="$LANG.Get('tooltips.removeItem')"
                              class="box-form-remove-button"><i class="fa-solid fa-trash"></i></span>
                    </div>
                    <NevsButton @click="addRecord('emails')"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.add') }}</NevsButton>
                </div>
                <div class="company-form-section">
                    <h2>{{ $LANG.Get('labels.phones') }}</h2>
                    <div v-if="companyValidation.phones" class="box-error nevs-text-error">{{ companyValidation.phones }}</div>
                    <div v-for="(phone, key) in company.phones" :key="key" class="box-form">
                        <NevsTextField :error="phone.validation.name" :label="'*' + $LANG.Get('fields.name') + ':'"
                                       v-model="phone.name"></NevsTextField>
                        <NevsTextField :error="phone.validation.number" :label="'*' + $LANG.Get('fields.number') + ':'"
                                       v-model="phone.number"></NevsTextField>
                        <br/><br/><br/>
                        <span @click="removeRecord(key, 'phones')" :title="$LANG.Get('tooltips.removeItem')"
                              class="box-form-remove-button"><i class="fa-solid fa-trash"></i></span>
                    </div>
                    <NevsButton @click="addRecord('phones')"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.add') }}</NevsButton>
                </div>
                <div class="company-form-section">
                    <h2 class="help-addresses">{{ $LANG.Get('labels.addresses') }}</h2>
                    <div v-if="companyValidation.addresses" class="box-error nevs-text-error">{{
                            companyValidation.addresses
                        }}
                    </div>
                    <div v-for="(address, key) in company.addresses" :key="key" class="box-form">
                        <NevsTextArea :error="address.validation.address" :label="$LANG.Get('fields.streetAndHouseNo')"
                                      v-model="address.address"></NevsTextArea>
                        <NevsTextField :error="address.validation.postal_code" :label="$LANG.Get('fields.postalCode')"
                                       v-model="address.postal_code"></NevsTextField>
                        <NevsTextField :error="address.validation.city" :label="$LANG.Get('fields.city')"
                                       v-model="address.city"></NevsTextField>
                        <NevsTextField :error="address.validation.country" :label="$LANG.Get('fields.country')"
                                       v-model="address.country"></NevsTextField>
                        <NevsCheckbox :label="$LANG.Get('fields.officialF')" v-model="address.official"></NevsCheckbox>
                        <span @click="removeRecord(key, 'addresses')" :title="$LANG.Get('tooltips.removeItem')"
                              class="box-form-remove-button"><i class="fa-solid fa-trash"></i></span>
                    </div>
                    <NevsButton @click="addRecord('addresses')"><i class="fa-solid fa-plus"></i> {{ $LANG.Get('buttons.add') }}</NevsButton>
                </div>
            </div>
        </NevsCard>
    </div>
</template>

<script>
import Company from '@/models/Company.js';
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTextArea from "@/components/nevs/NevsTextArea.vue";

export default {
    name: "EntityCompany",
    components: {NevsTextArea, NevsButton, NevsCheckbox, NevsTextField, NevsCard},
    data() {
        return {
            loaded: false,
            mode: this.$route.params.id === '0' ? 'add' : 'edit',
            company: new Company({id: this.$route.params.id}),
            companyValidation: new Company({}, true),
            templates: {
                emails: {
                    address: '',
                    documents: false,
                    validation: ''
                },
                phones: {
                    number: '',
                    name: '',
                    validation: {
                        number: '',
                        name: ''
                    }
                },
                addresses: {
                    address: '',
                    postal_code: '',
                    city: '',
                    country: '',
                    official: false,
                    validation: {
                        address: '',
                        postal_code: '',
                        city: '',
                        country: ''
                    }
                }
            }
        }
    },
    watch: {
        'company.foreign'() {
            if (this.loaded) {
                this.company.oib_label = 'OIB';
            }
        }
    },
    methods: {
        getDataFromRegister() {
            let vm = this;
            this.$API.APICall('get', 'companies/from-registry', {oib: this.company.oib}, (data, success) => {
                if (success) {
                    if (data.success) {
                        let registryData = data.data;
                        vm.company.name = registryData.name;
                        if (vm.company.addresses.length == 0) {
                            vm.addRecord('addresses');
                            vm.company.addresses[0].official = true;
                        }
                        vm.company.addresses[0].address = registryData.address;
                        vm.company.addresses[0].city = registryData.city;
                        vm.company.addresses[0].postal_code = registryData.postal_code;
                        vm.company.addresses[0].country = registryData.country;
                    } else {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.registryDataNotFound'),
                            type: 'alert'
                        });
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        removeRecord(key, type) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.generalRemovalQuestion'), callback: (response) => {
                    if (response) {
                        vm.company[type].splice(key, 1);
                    }
                }
            });
        },
        addRecord(type) {
            this.company[type].push(JSON.parse(JSON.stringify(this.templates[type])))
        },
        backClick() {
            if (window.history.length === 1) {
                window.close();
            } else {
                this.$router.back();
            }
        },
        saveClick() {
            if (this.company.addresses.length === 0) {
                this.company.addresses.push(this.templates.addresses);
            }
            if (this.company.addresses.length === 1) {
                this.company.addresses[0].official = true;
            }

            let valid = true;

            if (this.company.name === '') {
                valid = false;
                this.companyValidation.name = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.companyValidation.name = '';
            }

            if (this.company.last_name === '') {
                valid = false;
                this.companyValidation.last_name = this.$LANG.Get('labels.mandatoryField');
            } else {
                this.companyValidation.last_name = '';
            }

            if (this.company.oib !== '') {
                if (!this.company.foreign) {
                    if (!this.$HELPERS.CheckOIB(this.company.oib)) {
                        valid = false;
                        this.companyValidation.oib = this.$LANG.Get('labels.invalidOIB');
                    } else {
                        this.companyValidation.oib = '';
                    }
                } else {
                    this.companyValidation.oib = '';
                }
            }

            if (this.company.emails.length !== 0) {
                for (let email of this.company.emails) {
                    if (email.address === '') {
                        valid = false;
                        email.validation = this.$LANG.Get('labels.mandatoryField');
                    } else {
                        if (!this.$HELPERS.CheckEmail(email.address)) {
                            valid = false;
                            email.validation = this.$LANG.Get('labels.invalidEmailAddress');
                        } else {
                            email.validation = '';
                        }
                    }
                }
            } else {
                this.companyValidation.emails = '';
            }

            let official = 0;
            for (let address of this.company.addresses) {
                if (address.official) {
                    official++;
                }
            }
            if (official !== 1) {
                valid = false;
                this.companyValidation.addresses = this.$LANG.Get('labels.defaultAddressFail');
            } else {
                this.companyValidation.addresses = '';
            }

            for (let phone of this.company.phones) {
                if (phone.name === '') {
                    valid = false;
                    phone.validation.name = this.$LANG.Get('labels.mandatoryField');
                } else {
                    phone.validation.name = '';
                }
                if (phone.number === '') {
                    valid = false;
                    phone.validation.number = this.$LANG.Get('labels.mandatoryField');
                } else {
                    phone.validation.number = '';
                }
            }

            if (valid) {
                let vm = this;
                let requestMethod = this.mode === 'add' ? 'post' : 'put';
                let requestService = this.mode === 'add' ? 'companies' : 'companies/' + this.company.id;
                this.$API.APICall(requestMethod, requestService, this.company, (data, success) => {
                    if (success) {
                        vm.$CROSS_TAB_BUS.TriggerEvent('reload-companies', {});
                        vm.$LOCAL_BUS.TriggerEvent('notification', {text: this.$LANG.Get('alerts.recordSaved')});
                        vm.backClick();
                    } else {
                        if (data.error === 'oib_duplicate') {
                            vm.$LOCAL_BUS.TriggerEvent('popup', {
                                text: vm.$LANG.Get('alerts.oibDuplicate'),
                                type: 'alert'
                            });
                        } else {
                            vm.$HELPERS.HandleServerError(vm, data);
                        }
                    }
                })
            }
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-save',
                html: this.$LANG.Get('help.save'),
                left: -100,
                top: 0,
                width: 150
            },
            {
                class: 'help-back',
                html: this.$LANG.Get('help.back'),
                left: 85,
                top: -30,
                width: 300
            },
            {
                class: 'help-emails',
                html: this.$LANG.Get('help.emails'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-addresses',
                html: this.$LANG.Get('help.addresses'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-foreign',
                html: this.$LANG.Get('help.foreignCompany'),
                left: 200,
                top: -60,
                width: 400
            },
            {
                class: 'help-active',
                html: this.$LANG.Get('help.activeCompany'),
                left: 200,
                top: -40,
                width: 500
            }
        ]);

        this.$store.commit('selectMenu', 'clients');
        this.$store.commit('selectSubMenu', 'companies');

        if (this.mode === 'add') {
            this.$store.commit('setBreadcrumbs', [
                {
                    label: this.$LANG.Get('modules.companies'),
                    link: '/companies'
                },
                {
                    label: this.$LANG.Get('modules.newCompany'),
                    link: null
                }
            ]);
            this.loaded = true;
        } else {
            let vm = this;
            this.$API.APICall('get', 'companies/' + this.company.id, {}, (data, success) => {
                if (success) {
                    if (data.company !== null) {
                        vm.company.Fill(data.company);
                        vm.$store.commit('setBreadcrumbs', [
                            {
                                label: vm.$LANG.Get('modules.companies'),
                                link: '/companies'
                            },
                            {
                                label: vm.company.name,
                                link: null
                            }
                        ]);
                    } else {
                        vm.$HELPERS.HandleServerError(vm, data);
                    }
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
                vm.$nextTick(() => {
                    vm.loaded = true;
                });
            });
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.company-form {
    max-width: 1080px;
    padding: 16px;
}

.company-form h2 {
    margin: 0 0 8px;
}

// The scalar fields flow into as many columns as the viewport allows instead of stacking in a
// narrow 300px card.
.company-form-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 4px 12px;
    align-items: start;
    margin-top: 8px;
}

// The registry-lookup button sits beside the OIB field, aligned with the input rather than the
// label above it. This replaces a single-row <table> that was doing the same job.
.company-form-oib {
    display: flex;
    align-items: flex-start;

    :deep(.nevs-field) {
        flex: 1;
    }

    .nevs-button {
        margin-top: 26px;
    }
}

.company-form-foreign {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
    padding: 8px 5px 0;
}

.company-form-flags {
    display: flex;
    flex-wrap: wrap;
    gap: 10px 28px;
    padding: 10px 5px;
}

// The repeated e-mail / phone / address blocks, previously three floating cards, are now columns
// of one card so they line up and share its background.
.company-form-sections {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    gap: 22px;
    margin-top: 18px;
    padding-top: 16px;
    border-top: 1px solid $form-separator;
}

.company-form-section h2 {
    margin: 0 0 8px;
    font-size: 1.05em;
}

.box-form {
    background: $box-form-background;
    border-radius: 5px;
    margin-bottom: 5px;
    position: relative;
}

.box-error {
    font-size: 12px;
    margin-bottom: 5px;
    text-align: justify;
}

.box-form-remove-button {
    cursor: pointer;
    position: absolute;
    right: 5px;
    bottom: 5px;
}
</style>